import {productionConstants} from './productionConstants'
import {getAsync} from '../../../_metronic/helpers/httpClient'

export const getManufacturedProducts = (data) => async (dispatch) => {
  dispatch({
    type: productionConstants.GET_MANUFACTURED_PRODUCTS_REQUEST,
  })

  let queryString = '';
  if (data && data.manufacturingProductGroupTypes && Array.isArray(data.manufacturingProductGroupTypes)) {
    queryString = data.manufacturingProductGroupTypes.map(id => `manufacturingProductGroupTypes=${id}`).join('&');
  }

  const response = await getAsync(
    `/manufactured-products?${queryString}`
  )
  if (response.isSuccess) {
    dispatch({
      type: productionConstants.GET_MANUFACTURED_PRODUCTS_SUCCESS,
      payload: response.data,
    })
  } else {
    dispatch({
      type: productionConstants.GET_MANUFACTURED_PRODUCTS_FAILURE,
      payload: response,
    })
  }
}

export const clearManufacturedProducts = () => (dispatch) => {
  dispatch({
    type: productionConstants.CLEAR_MANUFACTURED_PRODUCTS,
  })
}
